// Toggle menu
const body = document.querySelector("body");
const toggleMenuButton = document.querySelector(".js-toggle-menu-button");
const overlay = document.querySelector(".js-overlay");
const menuLinks = document.querySelectorAll(".js-menu__link");

const toggleMenu = () => {
  body.classList.toggle("toggle-menu-active");
};

toggleMenuButton.addEventListener("click", toggleMenu);

overlay.addEventListener("click", toggleMenu);

menuLinks.forEach((item) => {
  item.addEventListener("click", () => {
    body.classList.remove("toggle-menu-active");
  });
});
